import { render, staticRenderFns } from "./subject.vue?vue&type=template&id=7a9ec2fa&scoped=true&"
import script from "./subject.vue?vue&type=script&lang=js&"
export * from "./subject.vue?vue&type=script&lang=js&"
import style0 from "./subject.vue?vue&type=style&index=0&id=7a9ec2fa&scoped=true&lang=css&"
import style1 from "./subject.vue?vue&type=style&index=1&id=7a9ec2fa&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ec2fa",
  null
  
)

export default component.exports